export default {
    methods: {
        login(username, password) {
            return this.post(`/user/login`, {
                username: username,
                password: password
            });
        },
        getUserData() {
            return this.get(`/user/data`);
        },
    }
}
